export const cableMessageTypes = {
  MESSAGE_CREATED: 'message_created',
  MESSAGE_DESTROYED: 'message_destroyed',
  PATIENT_CREATED: 'patient_created',
  PATIENT_UPDATED: 'patient_updated',
  PATIENT_DESTROYED: 'patient_destroyed',
  CONVERSATION_UPDATED: 'conversation_updated',
  READ_CREATED: 'read_created',
  APPOINTMENT_ANALYSIS_STATUS_UPDATED: 'appointment_analysis_status_updated',
  APPOINTMENT_ANALYSIS_CREATED: 'appointment_analysis_created',
  FIRST_ANALYSIS_STATUS_UPDATED: 'first_analysis_status_updated',
  FIRST_ANALYSIS_CREATED: 'first_analysis_created',
  SECOND_ANALYSIS_STATUS_UPDATED: 'second_analysis_status_updated',
  SECOND_ANALYSIS_CREATED: 'second_analysis_created',
  THIRD_ANALYSIS_STATUS_UPDATED: 'third_analysis_status_updated',
  THIRD_ANALYSIS_CREATED: 'third_analysis_created',
  FIFTH_ANALYSIS_STATUS_UPDATED: 'fifth_analysis_status_updated',
  FIFTH_ANALYSIS_CREATED: 'fifth_analysis_created',
  SIXTH_ANALYSIS_STATUS_UPDATED: 'sixth_analysis_status_updated',
  SIXTH_ANALYSIS_CREATED: 'sixth_analysis_created',
  STUDY_ANALYSIS_STATUS_UPDATED: 'study_analysis_status_updated',
  STUDY_ANALYSIS_CREATED: 'study_analysis_created',
  SEVENTH_ANALYSIS_STATUS_UPDATED: 'seventh_analysis_status_updated',
  SEVENTH_ANALYSIS_CREATED: 'seventh_analysis_created',
  WATERFALL_ANALYSIS_STATUS_UPDATED: 'waterfall_analysis_status_updated',
  WATERFALL_ANALYSIS_CREATED: 'waterfall_analysis_created',
  FILL_ANALYSIS_STATUS_UPDATED: 'fill_analysis_status_updated',
  FILL_ANALYSIS_CREATED: 'fill_analysis_created',
  ESIGN_ANALYSIS_STATUS_UPDATED: 'esign_analysis_status_updated',
  ESIGN_ANALYSIS_CREATED: 'esign_analysis_created',
  VOICE_ANALYSIS_STATUS_UPDATED: 'voice_analysis_status_updated',
  VOICE_ANALYSIS_CREATED: 'voice_analysis_created',
  REMINDER_ANALYSIS_STATUS_UPDATED: 'reminder_analysis_status_updated',
  REMINDER_ANALYSIS_CREATED: 'reminder_analysis_created',
  REFERRAL_ANALYSIS_STATUS_UPDATED: 'referral_analysis_status_updated',
  REFERRAL_ANALYSIS_CREATED: 'referral_analysis_created',
  SCHEDULE_ANALYSIS_STATUS_UPDATED: 'schedule_analysis_status_updated',
  SCHEDULE_ANALYSIS_CREATED: 'schedule_analysis_created',
  CONFIRM_ANALYSIS_STATUS_UPDATED: 'confirm_analysis_status_updated',
  CONFIRM_ANALYSIS_CREATED: 'confirm_analysis_created',
  PEN_STUDY_ANALYSIS_STATUS_UPDATED: 'pen_study_analysis_status_updated',
  PEN_STUDY_ANALYSIS_CREATED: 'pen_study_analysis_created',
  SUPERBILL_ANALYSIS_STATUS_UPDATED: 'superbill_analysis_status_updated',
  SUPERBILL_ANALYSIS_CREATED: 'superbill_analysis_created',
  BOOK_ANALYSIS_STATUS_UPDATED: 'book_analysis_status_updated',
  BOOK_ANALYSIS_CREATED: 'book_analysis_created',
  PATIENT_ANALYSIS_STATUS_UPDATED: 'patient_analysis_status_updated',
  PATIENT_ANALYSIS_CREATED: 'patient_analysis_created'
};
export const errorTypes = {
  ACCESS_TOKEN_INVALID: 'access_token_invalid',
  AUTHORIZE_DATA_INVALID: 'authorize_data_invalid',
  NOT_AUTHENTICATED: 'not_authenticated',
  RECORD_NOT_FOUND: 'record_not_found'
};
export const errorMessages = {
  ACCESS_TOKEN_INVALID: 'Authorization problems',
  AUTHORIZE_DATA_INVALID: 'Incorrect email or password',
  ACCESS_FORBIDDEN: 'Access forbidden',
  RECORD_NOT_FOUND: 'Record not found',
  TOO_MANY_REQUESTS: 'Too many attempts, please try again later',
  NOT_AUTHENTICATED: 'Incorrect login credentials',
  ACCESS_TOKEN_EMPTY: 'param is missing or the value is empty: access_token'
};
export const languages = [
  'en', 'ar', 'bg', 'ca-CAT', 'ca', 'da-DK', 'de-AT', 'de-CH', 'de', 'ee', 'en-AU', 'en-BORK', 'en-CA', 'en-GB', 'en-IND', 'en-MS', 
  'en-NEP', 'en-NG', 'en-NZ', 'en-PAK', 'en-SG', 'en-TH', 'en-UG', 'en-US', 'en-ZA', 'en-au-ocker', 'es-AR', 'es-MX', 'es', 'fa', 
  'fi-FI', 'fr', 'fr-CA', 'fr-CH', 'he', 'hy', 'id', 'it', 'ja', 'ko', 'lt', 'lv', 'mi-NZ', 'nb-NO', 'nl', 'no-NO', 'pl', 'pt-BR', 
  'pt', 'ru', 'sk', 'sv', 'th', 'tr', 'uk', 'vi', 'zh-CN', 'zh-TW', 'km', 'af'
];
export const channels = [
  'sms', 
  'email', 
  'widget'
];
export const representationVariants = {
  TINY: 'tiny', // 250x250
  SMALL: 'small', // 500x500
  MEDIUM: 'medium', // 600x600
};
export const elementableTypes = {
  DATE: 'date_element',
  TEXT: 'text_element',
  SIGNATURE: 'signature_element'
};
export const timezones = [
  'US/Alaska',
  'US/Aleutian',
  'US/Arizona',
  'US/Central',
  'US/East-Indiana',
  'US/Eastern',
  'US/Hawaii',
  'US/Indiana-Starke',
  'US/Michigan',
  'US/Mountain',
  'US/Pacific',
  'US/Samoa'
];
export const triggers = [
  { value: 'new_patient', label: 'New Patient'}, 
  { value: 'returning_patient', label: 'Returning Patient'},
  { value: 'rescheduling', label: 'Rescheduling'}, 
  { value: 'general_inquiry', label: 'General Inquiry'},
  { value: 'referral_source', label: 'Referral Source'}, 
  { value: 'appointment_confirmation', label: 'Appointment Confirmation'},
  { value: 'patient_info_gathering', label: 'Patient Info Gathering'}
];
export const modes = [
  { value: 'auto', label: 'Auto'}, 
  { value: 'approve', label: 'Approve'},
  { value: 'gate', label: 'User Gate'}, 
  { value: 'manual', label: 'Manual'}
];
